import React  from 'react';

import UserIconDeprecated from 'core/gd-components/icons/user/user-icon-deprecated';

export default function renderUrlGroupTListHeader1(id, props) {
    const user = gd.session.users.get(props.data.value);

    return (
        <React.Fragment>
            {!!user && <UserIconDeprecated className="m-r-10" size="22" userId={props.data.value}/>}
            <div className="text ui5-txt-default">{user ? user.name : 'No user'}</div>
        </React.Fragment>
    );
}